import { render, staticRenderFns } from "./ChatMessageContent.vue?vue&type=template&id=4dc77240&"
import script from "./ChatMessageContent.vue?vue&type=script&lang=ts&"
export * from "./ChatMessageContent.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessageContent.vue?vue&type=style&index=0&id=4dc77240&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports